module.exports = __webpack_public_path__ + "static/media/golf-carousel-2-640x360.b53335e8.jpg";